import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const listPricing = () =>
  axios.get(`${BASE}/api/v1/ai/pricing`, { headers: authHeaders() });

export const createPricing = (payload) =>
  axios.post(`${BASE}/api/v1/ai/pricing`, payload, { headers: authHeaders() });

export const updatePricing = (modelPid, payload) =>
  axios.put(`${BASE}/api/v1/ai/pricing/${modelPid}`, payload, { headers: authHeaders() });
